import { apiSlice } from "../../../app/apiSlice";

const activityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActivityLogs: builder.query({
      query: ({
        page = 1,
        per_page = 10,
        date_from,
        date_to,
        activity_type,
        actor_user_id,
      } = {}) => ({
        url: "/activity/all",
        params: {
          page,
          per_page,
          ...(date_from ? { date_from } : {}),
          ...(date_to ? { date_to } : {}),
          ...(activity_type ? { activity_type } : {}),
          ...(actor_user_id ? { actor_user_id } : {}),
        },
      }),
    }),
  }),
});

export const { useGetActivityLogsQuery } = activityApiSlice;
